import * as Yup from 'yup'
import { fieldsValidation } from 'primsell-shared-layer/utils'
import { IPublicCampaign } from 'primsell-shared-layer/types'

export interface IBuyFormValidationSchemaArgs {
  inStock?: IPublicCampaign['inStock']
}

export const buyFormValidationSchema = ({ inStock }: IBuyFormValidationSchemaArgs) =>
  Yup.object().shape({
    amount: inStock
      ? Yup.number()
          .min(1, 'Amount must be at least 1')
          .max(inStock, `The amount is not matching the available items in stock`)
          .required(fieldsValidation.REQUIRED)
      : Yup.number().min(1, 'Amount must be at least 1').required(fieldsValidation.REQUIRED),
    email: Yup.string().email('Invalid email format').required(fieldsValidation.REQUIRED),
    firstName: Yup.string().required(fieldsValidation.REQUIRED),
    lastName: Yup.string().required(fieldsValidation.REQUIRED),
  })
